import { render, staticRenderFns } from "./ProfileAppointments.vue?vue&type=template&id=28db73be&scoped=true"
import script from "./ProfileAppointments.vue?vue&type=script&lang=js"
export * from "./ProfileAppointments.vue?vue&type=script&lang=js"
import style0 from "./ProfileAppointments.vue?vue&type=style&index=0&id=28db73be&prod&lang=scss&scoped=true"
import style1 from "./ProfileAppointments.vue?vue&type=style&index=1&id=28db73be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28db73be",
  null
  
)

export default component.exports